import { FC } from "react";
import i18next from "i18next";
import { Flex, Text, Button, Spinner, Heading } from "@radix-ui/themes";
import { VerificationCodeInput } from "./VerificationCodeInput"; // Assume this is the actual input component

interface AuthCodeFormProps {
  code: {
    0: number | null;
    1: number | null;
    2: number | null;
    3: number | null;
    4: number | null;
    5: number | null;
  };
  setFieldValue: (index: number, value: number | null) => void;
  requestFunction: () => Promise<void>;
  loading: boolean;
}

export const AuthCodeForm: FC<AuthCodeFormProps> = ({
  code,
  setFieldValue,
  requestFunction,
  loading,
}) => {
  return (
    <Flex direction="column" gap="4">
      <Flex direction="column" gap="2">
        <Heading size="3" mb="0">
          {i18next.t("auth.verify.headline")}
        </Heading>
        <Text size="2">{i18next.t("auth.verify.validity")}</Text>
      </Flex>

      <VerificationCodeInput code={code} setFieldValue={setFieldValue} />

      <Flex justify="center" pt="2">
        <Button
          size="2"
          variant="outline"
          disabled={loading}
          onClick={requestFunction}
        >
          {loading ? (
            <Spinner size="1" />
          ) : (
            i18next.t("auth.input.button.request")
          )}
        </Button>
      </Flex>
    </Flex>
  );
};
